import { TextField, useTheme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import api from "../../services/api";
import CustomTooltip from "./CustomTooltip";
import Title from "./Title";
import { toast } from "react-toastify";

const ChartPorPlataformaSistema = () => {
  const theme = useTheme();
  const [plataformaSistemaChartData, setPlataformaSistemaChartData] = useState(
    []
  );
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [initialSelectedDate, setInitialSelectedDate] =
    useState(getCurrentDate);
  const [finalSelectedDate, setFinalSelectedDate] = useState(getCurrentDate);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchTicketsPorPlataformaSistemas = async () => {
        try {
          const { data } = await api.get("/tickets-por-plataforma-sistema", {
            params: {
              initialSelectedDate,
              finalSelectedDate,
            },
          });

          setPlataformaSistemaChartData(data.ticketsPorPlataformaSistema);
        } catch (error) {
          toast.error(
            "Erro ao carregar gráfico de Tickets por Plataforma/Sistema!"
          );
        }
      };

      fetchTicketsPorPlataformaSistemas();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [initialSelectedDate, finalSelectedDate]);

  return (
    <React.Fragment>
      <Title>{"Tickets por Plataforma/Sistema"}</Title>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <TextField
          label={"Data inicial"}
          type="date"
          value={initialSelectedDate}
          onChange={(e) => setInitialSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label={"Data final"}
          type="date"
          value={finalSelectedDate}
          onChange={(e) => setFinalSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <ResponsiveContainer>
        <BarChart
          data={plataformaSistemaChartData}
          barSize={40}
          width={730}
          height={300}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="nomePlataformaSistema"
            stroke={theme.palette.text.secondary}
          />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: "middle", fill: theme.palette.text.primary }}
            >
              {"Ticket"}
            </Label>
          </YAxis>
          <Tooltip content={<CustomTooltip />} cursor={true} />
          <Bar dataKey="quantidade" fill={theme.palette.primary.main} />
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default ChartPorPlataformaSistema;
